import script from "./SurveyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SurveyView.vue?vue&type=script&lang=ts&setup=true"

import "./SurveyView.vue?vue&type=style&index=0&id=01f043a7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01f043a7"]])

export default __exports__